import SSearch from "@public/image/icon/search.svg";
import { ComponentProps } from "react";

interface FAQInputProps extends ComponentProps<"input"> {
  className?: string;
}

function FAQInput({ className, ...props }: FAQInputProps) {
  return (
    <div className={`relative ${className}`}>
      <SSearch
        width={28}
        height={28}
        className="absolute left-6 top-1/2 size-6 -translate-y-1/2 fill-gray/50"
        aria-label="검색"
      />
      <input
        className="w-full rounded-full border border-gray/20 px-4 py-4 pl-16 text-20 shadow-primary/20 outline-none focus-visible:shadow-[0_0_10px_0_#3960f833]"
        placeholder="검색어를 입력해주세요."
        {...props}
      />
    </div>
  );
}

export default FAQInput;
